import PropTypes from 'prop-types';
import React from 'react';

const Page = React.lazy(()=>import('./FacebookChatViaPage'))

export default function LazyFacebookChat(props){
    return <React.Suspense fallback={null}>
        <Page fb_page_id={props.fb_page_id} />
    </React.Suspense>
}

LazyFacebookChat.propTypes = {
    fb_page_id: PropTypes.string.isRequired,
};
